export const getYmGoal = (
  type: 'tariff' | 'about' | 'monthly' | 'full' | 'compare' | 'hide' | 'option' | 'select' | 'modal_about' | 'close_tariff'
): string => {
  const path = window.location.pathname;
  const isParents = path.includes('/parents/');
  const isTeachers = path.includes('/teachers/');
  const isCatalog = path.includes('/course/') || path.includes('/courses/');
  if (type === 'monthly') {
    if (isCatalog) return 'click_coursepage_monthly';
    if (isParents) return 'click_modal_monthly_parents';
    if (isTeachers) return 'click_modal_monthly_teachers';
    if (/^\/?$/.test(path)) return 'click_modal_monthly_students';
    return '';
  }
  if (type === 'full') {
    if (isCatalog) return 'click_catalog_modal_full';
    if (isParents) return 'click_modal_full_parents';
    if (isTeachers) return 'click_modal_full_teachers';
    if (/^\/?$/.test(path)) return 'click_modal_full_students';
    return '';
  }
  if (type === 'compare') {
    if (isCatalog) return 'click_catalog_modal_compare';
    if (isParents) return 'click_modal_compare_parents';
    if (isTeachers) return 'click_modal_compare_teachers';
    if (/^\/?$/.test(path)) return 'click_modal_compare_students';
    return '';
  }
  if (type === 'hide') {
    if (isCatalog) return 'click_catalog_modal_hide';
    if (isParents) return 'click_modal_hide_parents';
    if (isTeachers) return 'click_modal_hide_teachers';
    if (/^\/?$/.test(path)) return 'click_modal_hide_students';
    return '';
  }
  if (type === 'option') {
    if (isCatalog) return 'click_catalog_modal_option';
    if (isParents) return 'click_modal_option_parents';
    if (isTeachers) return 'click_modal_option_teachers';
    if (/^\/?$/.test(path)) return 'click_modal_option_students';
    return '';
  }
  if (type === 'select') {
    if (isCatalog) return 'click_catalog_modal_select';
    if (isParents) return 'click_modal_select_parents';
    if (isTeachers) return 'click_modal_select_teachers';
    if (/^\/?$/.test(path)) return 'click_modal_select_students';
    return '';
  }
  if (type === 'modal_about') {
    if (isCatalog) return 'click_catalog_modal_about';
    if (isParents) return 'click_modal_about_parents';
    if (isTeachers) return 'click_modal_about_teachers';
    if (/^\/?$/.test(path)) return 'click_modal_about_students';
    return '';
  }
  if (type === 'close_tariff') {
    if (isCatalog) return 'close_catalog_modal_tariff';
    if (isParents) return 'close_modal_tariff_parents';
    if (isTeachers) return 'close_modal_tariff_teachers';
    if (/^\/?$/.test(path)) return 'close_modal_tariff_students';
    return '';
  }
  if (isCatalog) {
    return type === 'tariff' ? 'click_catalog_tariff_card' : 'click_catalog_about_card';
  }
  if (isParents) {
    return type === 'tariff' ? 'click_card_tariff_parents' : 'click_card_about_parents';
  }
  if (isTeachers) {
    return type === 'tariff' ? 'click_card_tariff_teachers' : 'click_card_about_teachers';
  }
  // students: если после .ru нет ничего
  if (/^\/?$/.test(path)) {
    return type === 'tariff' ? 'click_card_tariff_students' : 'click_card_about_students';
  }
  // Если не подходит ни под одно условие, не выводим атрибут
  return '';
};
